// src/config.ts
const countryLocale = window.location.pathname.split('/')[1];

const getBcSupportUrl = (countryLocale: string): string => {
  // Special cases mapping
  const specialCases: Record<string, string> = {
    'en-hk': 'https://www.nvidia.cn/contact/asia/',
    'en-me': 'https://www.nvidia.com/en-eu/support/consumer/',
    'es-mx': 'https://www.nvidia.com/es-la/support/',
    'pt-br': 'https://www.nvidia.com/pt-br/support/',
    'zh-tw': 'https://www.nvidia.com/zh-tw/support/',
    'en-ph': ' https://www.nvidia.com/en-us/support/consumer/',
    'nl-nl': 'https://www.nvidia.com/en-eu/support/',
    'fi-fi': 'https://www.nvidia.com/en-eu/support/',
    'da-dk': 'https://www.nvidia.com/en-eu/support/'
  };

  // Check if it's a special case first
  if (specialCases[countryLocale]) {
    return specialCases[countryLocale];
  }

  // Default case: build URL with consumer support
  return `https://www.nvidia.com/${countryLocale}/support/consumer/`;
};

export const config = {
  apiUrl: "https://api.store.nvidia.com/",
  environment: process.env.REACT_APP_ENV,
  captchaKey: '6LdaPbYpAAAAAKLr73O8Zx2q2L4-M23j0eWsuU2r',
  mapKey: 'AIzaSyCmr3TDerqHtSyzJw1R8VLPn0kwxXeP6rA',
  bcSSOLoginUrl: `https://login.nvidia.com/authorize?response_type=code&client_id=DMWNMJvkydnyMCjov_-srdYYIjU70Kg8PCMfg6akIhk&redirect_uri=https://api.store.nvidia.com/account/v1/auth&ui_locales=${countryLocale.replace('-', '_').split('_').map((part, index) => index === 1 ? part.toUpperCase() : part).join('_')}&scope=openid%20profile%20email&state=https://marketplace.nvidia.com/`,
  bcSupportUrl: getBcSupportUrl(countryLocale),
  bcOrdersUrl: 'https://marketplace.nvidia.com/' + countryLocale + '/account/my-orders',
  bcAddressesUrl: 'https://marketplace.nvidia.com/' + countryLocale + '/account/address-information',
  registeredShopperAPI: 'https://api.store.nvidia.com/account/v1/marketplace/customer',
  accountURL: 'https://marketplace.nvidia.com/' + countryLocale + '/account/'
};